import { AudioDetailsForm } from "./AudioDetailsForm";

export * from "./AudioDetailsForm";
export default AudioDetailsForm;
